module.exports = __webpack_public_path__ + "static/media/UA.7e137f02.png";